<template>
  <div id="app">
    <router-view class="page-view" />
    <van-tabbar
      v-if="showTabbar"
      v-model="activeTab"
      :fixed="true"
      :safe-area-inset-bottom="true"
      active-color="rgb(242,124,52)"
      inactive-color="#969799"
      @change="onTabChange"
    >
      <van-tabbar-item icon="friends-o" name="customer-track">学员管理</van-tabbar-item>
      <van-tabbar-item icon="clock-o" name="course-consumed">课消管理</van-tabbar-item>
      <van-tabbar-item icon="balance-list-o" name="income-manage">收入管理</van-tabbar-item>
      <van-tabbar-item icon="balance-o" name="expense-approval">报销管理</van-tabbar-item>
      <van-tabbar-item icon="wap-nav" name="more" @click="openMoreMenu">更多</van-tabbar-item>
    </van-tabbar>

    <van-action-sheet
      v-model="moreMenuShow"
      :actions="moreMenuActions"
      cancel-text="取消"
      close-on-click-action
      @select="onMoreMenuSelect"
    />
  </div>
</template>

<script>
const MORE_TAB = "more"

const ROUTE_TAB_MAP = {
  CustomerTrack: "customer-track",
  CourseConsumed: "course-consumed",
  MaterialApproval: MORE_TAB,
  ExpenseApproval: "expense-approval",
  IncomeManage: "income-manage",
  RefundApproval: MORE_TAB,
  TransferCenterApproval: MORE_TAB,
  ProjectManage: MORE_TAB
}

const TAB_ROUTE_MAP = {
  "customer-track": "/customer-track",
  "course-consumed": "/course-consumed",
  "expense-approval": "/expense-approval",
  "income-manage": "/income-manage"
}

const MORE_MENU_ACTIONS = [
  { name: "项目管理", path: "/project-manage" },
  { name: "教材管理", path: "/material-approval" },
  { name: "退费管理", path: "/refund-approval" },
  { name: "转中心", path: "/transfer-center-approval" }
]

export default {
  name: "App",
  data() {
    return {
      activeTab: "customer-track",
      moreMenuShow: false,
      moreMenuActions: MORE_MENU_ACTIONS
    }
  },
  computed: {
    showTabbar() {
      return true
    }
  },
  watch: {
    $route(to) {
      this.syncActiveTabFromRoute(to.name)
    }
  },
  mounted() {
    this.syncActiveTabFromRoute(this.$route.name)
  },
  methods: {
    isMoreRoute(routeName) {
      return ROUTE_TAB_MAP[routeName] === MORE_TAB
    },
    syncActiveTabFromRoute(routeName) {
      const tab = ROUTE_TAB_MAP[routeName]
      if (tab && tab !== this.activeTab) {
        this.activeTab = tab
      }
    },
    openMoreMenu() {
      this.moreMenuShow = true
    },
    onTabChange(name) {
      if (name === MORE_TAB) {
        this.openMoreMenu()
        if (!this.isMoreRoute(this.$route.name)) {
          this.$nextTick(() => {
            this.syncActiveTabFromRoute(this.$route.name)
          })
        }
        return
      }
      const path = TAB_ROUTE_MAP[name]
      if (path && this.$route.path !== path) {
        this.$router.push(path)
      }
    },
    onMoreMenuSelect(action) {
      const path = action?.path
      if (path && this.$route.path !== path) {
        this.$router.push(path)
      }
      this.activeTab = MORE_TAB
    }
  }
}
</script>

<style>
:root {
  --app-tabbar-height: 50px;
  --app-safe-area-bottom: constant(safe-area-inset-bottom);
  --app-safe-area-bottom: env(safe-area-inset-bottom, 0px);
  --app-tabbar-offset: calc(var(--app-tabbar-height) + var(--app-safe-area-bottom));
}

#app {
  min-height: 100vh;
}

.page-view {
  padding-bottom: var(--app-tabbar-offset);
}
</style>
